export function getSchedulerUserFriendlyName(name) {
  return name?.substr(name?.indexOf('__') + 2);
}
